module.exports = __webpack_public_path__ + "static/KF_logo-stacked-bb4853089d53831e648eaaf319706e12.png";